import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./reducers/authReducer";
import botReducer from "./reducers/botReducer";

export const store = configureStore({
  reducer: { auth: authReducer, bot: botReducer },
});
